import { encodeSHA256, encryptAES } from '../../core-apis/src/apis/config/utils'
import { convertSnakeCaseToCamelCase } from '../../web-components/utils/formatterResponse'

const AUTH_KEY_SECRET = process.env.AUTH_KEY_SECRET

export interface IFetchServerResponse {
  data: any
  status: number
  isError: boolean
}

export const fetchServerAuth = async (
  url: string,
  token: string,
  options?: RequestInit
): Promise<IFetchServerResponse> => {
  const res = await fetch(url, {
    ...options,
    headers: {
      Authorization: token,
      ...options?.headers
    }
  })
  const data = await res?.json()

  return {
    data: data ? convertSnakeCaseToCamelCase(data) : res,
    status: res?.status,
    isError: !res?.ok
  }
}

export const fetchServerXBasicAuth = async (
  url: string,
  options?: RequestInit
) => {
  const timestamp = Date.now()
  const token = encodeSHA256(timestamp, AUTH_KEY_SECRET as string)

  const headers = {
    ...options?.headers,
    timestamp: `${timestamp}`,
    Authorization: `${token}`
  }
  const res = await fetch(url, {
    ...options,
    headers
  })

  const data = await res?.json()

  return {
    data: data ? convertSnakeCaseToCamelCase(data) : res,
    status: res?.status,
    isError: !res?.ok
  }
}
export const fetchServerXAuth = async (
  url: string,
  userId: string,
  options?: RequestInit
) => {
  const timestamp = Date.now()
  const token = encodeSHA256(timestamp, AUTH_KEY_SECRET as string)

  const xCustomAuth = {
    userId
  }

  const encryptedXCustomAuth = encryptAES(
    xCustomAuth,
    AUTH_KEY_SECRET?.toString() as string
  )

  const headers = {
    ...options?.headers,
    timestamp: `${timestamp}`,
    Authorization: `${token}`,
    'X-Custom-Auth': `${encryptedXCustomAuth}`
  }

  const res = await fetch(url, {
    ...options,
    headers
  })

  const data = await res?.json()

  return {
    data: data ? convertSnakeCaseToCamelCase(data) : res,
    status: res?.status,
    isError: !res?.ok
  }
}

export const fetchServerXAuthWithBinaryRole = async (
  url: string,
  userId: string,
  binaryRole: number,
  agencyId?: string,
  options?: RequestInit
) => {
  const timestamp = Date.now()
  const token = encodeSHA256(timestamp, AUTH_KEY_SECRET as string)

  const xCustomAuth = {
    userId,
    roles: binaryRole,
    agencyId
  }

  const encryptedXCustomAuth = encryptAES(
    xCustomAuth,
    AUTH_KEY_SECRET?.toString() as string
  )

  const headers = {
    ...options?.headers,
    timestamp: `${timestamp}`,
    Authorization: `${token}`,
    'X-Custom-Auth': `${encryptedXCustomAuth}`
  }

  const res = await fetch(url, {
    ...options,
    headers
  })

  const data = await res?.json()

  return {
    data: data ? convertSnakeCaseToCamelCase(data) : res,
    status: res?.status,
    isError: !res?.ok
  }
}

export const fetchServerLegacyAuth = async ({
  legacyToken,
  url,
  options
}: {
  url: string
  legacyToken: string
  options?: RequestInit
}) => {
  const headers = {
    ...options?.headers,
    Authorization: `${legacyToken}`
  }

  const res = await fetch(url, {
    ...options,
    headers
  })

  const data = await res?.json()

  return {
    data: data ? convertSnakeCaseToCamelCase(data) : res,
    status: res?.status,
    isError: !res?.ok
  }
}
